module.exports = __webpack_public_path__ + "static/media/4_n.f3396d13.jpg";